import React from 'react';

const CheckCircleFilledIcon = ({fill = "#229DEC"}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 32)" fill="url(#paint0_linear_541_2459)"/>
    <circle cx="14" cy="14" r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 2 30)" fill="white"/>
    <g clipPath="url(#clip0_541_2459)">
      <path d="M16.0002 9.3335C12.3202 9.3335 9.3335 12.3202 9.3335 16.0002C9.3335 19.6802 12.3202 22.6668 16.0002 22.6668C19.6802 22.6668 22.6668 19.6802 22.6668 16.0002C22.6668 12.3202 19.6802 9.3335 16.0002 9.3335ZM14.6668 19.3335L11.3335 16.0002L12.2735 15.0602L14.6668 17.4468L19.7268 12.3868L20.6668 13.3335L14.6668 19.3335Z" fill={fill} />
    </g>
    <defs>
      <linearGradient id="paint0_linear_541_2459" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2580AC"/>
        <stop offset="0.885417" stopColor="#00AAFF"/>
      </linearGradient>
      <clipPath id="clip0_541_2459">
        <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
      </clipPath>
    </defs>
  </svg>

);

export default CheckCircleFilledIcon;



